<!-- Base.Tab.vue (client) -->
<template tag="클라이언트 탭 컴포넌트">
  <div :class="classNames">
    <div v-if="isSwiper" class="swiper-container primary">
      <div class="swiper-wrapper">
        <Swiper
          tag="div"
          v-bind="props.swiperOptions"
          :space-between="responsiveGap"
          :free-mode="false"
          @swiper="onSwiperInit"
        >
          <SwiperSlide v-for="(tab, index) in tabs" :key="index" tag="div">
            <p :class="[type, { disabled: tab.disabled }]">
              <label>
                <input
                  v-model="selectedTab"
                  type="radio"
                  :value="tab.value"
                  :disabled="tab.disabled"
                />
                {{ tab.label }}
                <span v-if="tabCount && tabCount[index] !== undefined">{{ tabCount[index] }}</span>
              </label>
            </p>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <!-- Swiper가 아니면 그냥 기존 방식으로 -->
    <template v-else>
      <p v-for="(tab, index) in tabs" :key="index" :class="[type, { disabled: tab.disabled }]">
        <label>
          <input type="radio" v-model="selectedTab" :value="tab.value" :disabled="tab.disabled" />
          {{ tab.label }}
          <span v-if="tabCount && tabCount[index] !== undefined">{{ tabCount[index] }}</span>
        </label>
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed, ref, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "@/assets/common/css/swiper.css";
import type { Swiper as SwiperType } from "swiper";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const selectedTab = defineModel<string>();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  modelValue: { type: String, default: "" },
  type: { type: String, default: "" },
  tabs: { type: Array<{ label: string; value: string; disabled?: boolean }>, default: () => [] },
  tabCount: { type: Array<number>, default: () => [] },
  isSwiper: { type: Boolean, default: false },
  gap: { type: Number, default: 8 },
  gap768: { type: Number, default: 6 },
  swiperOptions: {
    type: Object,
    default: () => ({
      slidesPerView: "auto",
      freeMode: false,
      centeredSlides: false,
      loop: false,
    }),
  },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
// const effectiveGap = ref(props.type === "line_tab" ? 0 : props.gap);
// const effectiveGap768 = ref(props.type === "line_tab" ? 0 : props.gap768);
const effectiveGap = ref(
  props.type === "line_tab" || props.type === "segment_tab"
    ? 0
    : props.type === "deco_text_tab"
      ? 16
      : props.gap
);
const effectiveGap768 = ref(
  props.type === "line_tab" || props.type === "segment_tab"
    ? 0
    : props.type === "deco_text_tab"
      ? 16
      : props.gap768
);

// 추가
const swiperInstance = ref<SwiperType | null>(null);
/* ------------------------------------------------------------
                          Computed Properties
   ------------------------------------------------------------ */
// 조건에 따라 자동으로 클래스 추가
const classNames = computed(() => {
  return {
    [`${props.type}_wrap`]: true,
    tab_swiper: props.isSwiper,
  };
});

// 반응형 gap 처리
const responsiveGap = computed(() => {
  return window.innerWidth <= 768 ? effectiveGap768.value : effectiveGap.value;
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
// Swiper 초기화
function onSwiperInit(swiper: SwiperType) {
  swiperInstance.value = swiper;
  scrollToSelectedTab();
}

// 탭 이동
function scrollToSelectedTab() {
  if (!swiperInstance.value || !props.tabs?.length) return;
  const idx = props.tabs.findIndex((t) => t.value === selectedTab.value);
  if (idx !== -1) swiperInstance.value.slideTo(idx, 300);
}

/* ------------------------------------------------------------
                          watch
   ------------------------------------------------------------ */
watch(() => selectedTab.value, scrollToSelectedTab);
</script>
